import { render } from "./ProjectRazzoContactForm.vue?vue&type=template&id=152b8e95"
import script from "./ProjectRazzoContactForm.vue?vue&type=script&lang=js"
export * from "./ProjectRazzoContactForm.vue?vue&type=script&lang=js"

import "./ProjectRazzoContactForm.vue?vue&type=style&index=0&id=152b8e95&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__